/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TunerRouteImport } from './routes/tuner'
import { Route as StyleguideRouteImport } from './routes/styleguide'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as ScalesQuizRouteImport } from './routes/scales-quiz'
import { Route as ScaleExplorerRouteImport } from './routes/scale-explorer'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as ProgressionsRouteImport } from './routes/progressions'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as PlayRouteImport } from './routes/play'
import { Route as IntervalsRouteImport } from './routes/intervals'
import { Route as EarTrainingRouteImport } from './routes/ear-training'
import { Route as DevRouteImport } from './routes/dev'
import { Route as CircleOfFifthsRouteImport } from './routes/circle-of-fifths'
import { Route as ChordScaleRouteImport } from './routes/chord-scale'
import { Route as ChordQuizRouteImport } from './routes/chord-quiz'
import { Route as ArpeggiosRouteImport } from './routes/arpeggios'
import { Route as IndexRouteImport } from './routes/index'

const TunerRoute = TunerRouteImport.update({
  id: '/tuner',
  path: '/tuner',
  getParentRoute: () => rootRouteImport,
} as any)
const StyleguideRoute = StyleguideRouteImport.update({
  id: '/styleguide',
  path: '/styleguide',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const ScalesQuizRoute = ScalesQuizRouteImport.update({
  id: '/scales-quiz',
  path: '/scales-quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const ScaleExplorerRoute = ScaleExplorerRouteImport.update({
  id: '/scale-explorer',
  path: '/scale-explorer',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewRoute = ReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => rootRouteImport,
} as any)
const ProgressionsRoute = ProgressionsRouteImport.update({
  id: '/progressions',
  path: '/progressions',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeRoute = PracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const PlayRoute = PlayRouteImport.update({
  id: '/play',
  path: '/play',
  getParentRoute: () => rootRouteImport,
} as any)
const IntervalsRoute = IntervalsRouteImport.update({
  id: '/intervals',
  path: '/intervals',
  getParentRoute: () => rootRouteImport,
} as any)
const EarTrainingRoute = EarTrainingRouteImport.update({
  id: '/ear-training',
  path: '/ear-training',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const CircleOfFifthsRoute = CircleOfFifthsRouteImport.update({
  id: '/circle-of-fifths',
  path: '/circle-of-fifths',
  getParentRoute: () => rootRouteImport,
} as any)
const ChordScaleRoute = ChordScaleRouteImport.update({
  id: '/chord-scale',
  path: '/chord-scale',
  getParentRoute: () => rootRouteImport,
} as any)
const ChordQuizRoute = ChordQuizRouteImport.update({
  id: '/chord-quiz',
  path: '/chord-quiz',
  getParentRoute: () => rootRouteImport,
} as any)
const ArpeggiosRoute = ArpeggiosRouteImport.update({
  id: '/arpeggios',
  path: '/arpeggios',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/arpeggios': typeof ArpeggiosRoute
  '/chord-quiz': typeof ChordQuizRoute
  '/chord-scale': typeof ChordScaleRoute
  '/circle-of-fifths': typeof CircleOfFifthsRoute
  '/dev': typeof DevRoute
  '/ear-training': typeof EarTrainingRoute
  '/intervals': typeof IntervalsRoute
  '/play': typeof PlayRoute
  '/practice': typeof PracticeRoute
  '/progressions': typeof ProgressionsRoute
  '/review': typeof ReviewRoute
  '/scale-explorer': typeof ScaleExplorerRoute
  '/scales-quiz': typeof ScalesQuizRoute
  '/stats': typeof StatsRoute
  '/styleguide': typeof StyleguideRoute
  '/tuner': typeof TunerRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/arpeggios': typeof ArpeggiosRoute
  '/chord-quiz': typeof ChordQuizRoute
  '/chord-scale': typeof ChordScaleRoute
  '/circle-of-fifths': typeof CircleOfFifthsRoute
  '/dev': typeof DevRoute
  '/ear-training': typeof EarTrainingRoute
  '/intervals': typeof IntervalsRoute
  '/play': typeof PlayRoute
  '/practice': typeof PracticeRoute
  '/progressions': typeof ProgressionsRoute
  '/review': typeof ReviewRoute
  '/scale-explorer': typeof ScaleExplorerRoute
  '/scales-quiz': typeof ScalesQuizRoute
  '/stats': typeof StatsRoute
  '/styleguide': typeof StyleguideRoute
  '/tuner': typeof TunerRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/arpeggios': typeof ArpeggiosRoute
  '/chord-quiz': typeof ChordQuizRoute
  '/chord-scale': typeof ChordScaleRoute
  '/circle-of-fifths': typeof CircleOfFifthsRoute
  '/dev': typeof DevRoute
  '/ear-training': typeof EarTrainingRoute
  '/intervals': typeof IntervalsRoute
  '/play': typeof PlayRoute
  '/practice': typeof PracticeRoute
  '/progressions': typeof ProgressionsRoute
  '/review': typeof ReviewRoute
  '/scale-explorer': typeof ScaleExplorerRoute
  '/scales-quiz': typeof ScalesQuizRoute
  '/stats': typeof StatsRoute
  '/styleguide': typeof StyleguideRoute
  '/tuner': typeof TunerRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/arpeggios'
    | '/chord-quiz'
    | '/chord-scale'
    | '/circle-of-fifths'
    | '/dev'
    | '/ear-training'
    | '/intervals'
    | '/play'
    | '/practice'
    | '/progressions'
    | '/review'
    | '/scale-explorer'
    | '/scales-quiz'
    | '/stats'
    | '/styleguide'
    | '/tuner'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/arpeggios'
    | '/chord-quiz'
    | '/chord-scale'
    | '/circle-of-fifths'
    | '/dev'
    | '/ear-training'
    | '/intervals'
    | '/play'
    | '/practice'
    | '/progressions'
    | '/review'
    | '/scale-explorer'
    | '/scales-quiz'
    | '/stats'
    | '/styleguide'
    | '/tuner'
  id:
    | '__root__'
    | '/'
    | '/arpeggios'
    | '/chord-quiz'
    | '/chord-scale'
    | '/circle-of-fifths'
    | '/dev'
    | '/ear-training'
    | '/intervals'
    | '/play'
    | '/practice'
    | '/progressions'
    | '/review'
    | '/scale-explorer'
    | '/scales-quiz'
    | '/stats'
    | '/styleguide'
    | '/tuner'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArpeggiosRoute: typeof ArpeggiosRoute
  ChordQuizRoute: typeof ChordQuizRoute
  ChordScaleRoute: typeof ChordScaleRoute
  CircleOfFifthsRoute: typeof CircleOfFifthsRoute
  DevRoute: typeof DevRoute
  EarTrainingRoute: typeof EarTrainingRoute
  IntervalsRoute: typeof IntervalsRoute
  PlayRoute: typeof PlayRoute
  PracticeRoute: typeof PracticeRoute
  ProgressionsRoute: typeof ProgressionsRoute
  ReviewRoute: typeof ReviewRoute
  ScaleExplorerRoute: typeof ScaleExplorerRoute
  ScalesQuizRoute: typeof ScalesQuizRoute
  StatsRoute: typeof StatsRoute
  StyleguideRoute: typeof StyleguideRoute
  TunerRoute: typeof TunerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tuner': {
      id: '/tuner'
      path: '/tuner'
      fullPath: '/tuner'
      preLoaderRoute: typeof TunerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styleguide': {
      id: '/styleguide'
      path: '/styleguide'
      fullPath: '/styleguide'
      preLoaderRoute: typeof StyleguideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scales-quiz': {
      id: '/scales-quiz'
      path: '/scales-quiz'
      fullPath: '/scales-quiz'
      preLoaderRoute: typeof ScalesQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scale-explorer': {
      id: '/scale-explorer'
      path: '/scale-explorer'
      fullPath: '/scale-explorer'
      preLoaderRoute: typeof ScaleExplorerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/review': {
      id: '/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof ReviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/progressions': {
      id: '/progressions'
      path: '/progressions'
      fullPath: '/progressions'
      preLoaderRoute: typeof ProgressionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice': {
      id: '/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof PracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/play': {
      id: '/play'
      path: '/play'
      fullPath: '/play'
      preLoaderRoute: typeof PlayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/intervals': {
      id: '/intervals'
      path: '/intervals'
      fullPath: '/intervals'
      preLoaderRoute: typeof IntervalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ear-training': {
      id: '/ear-training'
      path: '/ear-training'
      fullPath: '/ear-training'
      preLoaderRoute: typeof EarTrainingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/circle-of-fifths': {
      id: '/circle-of-fifths'
      path: '/circle-of-fifths'
      fullPath: '/circle-of-fifths'
      preLoaderRoute: typeof CircleOfFifthsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chord-scale': {
      id: '/chord-scale'
      path: '/chord-scale'
      fullPath: '/chord-scale'
      preLoaderRoute: typeof ChordScaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chord-quiz': {
      id: '/chord-quiz'
      path: '/chord-quiz'
      fullPath: '/chord-quiz'
      preLoaderRoute: typeof ChordQuizRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arpeggios': {
      id: '/arpeggios'
      path: '/arpeggios'
      fullPath: '/arpeggios'
      preLoaderRoute: typeof ArpeggiosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArpeggiosRoute: ArpeggiosRoute,
  ChordQuizRoute: ChordQuizRoute,
  ChordScaleRoute: ChordScaleRoute,
  CircleOfFifthsRoute: CircleOfFifthsRoute,
  DevRoute: DevRoute,
  EarTrainingRoute: EarTrainingRoute,
  IntervalsRoute: IntervalsRoute,
  PlayRoute: PlayRoute,
  PracticeRoute: PracticeRoute,
  ProgressionsRoute: ProgressionsRoute,
  ReviewRoute: ReviewRoute,
  ScaleExplorerRoute: ScaleExplorerRoute,
  ScalesQuizRoute: ScalesQuizRoute,
  StatsRoute: StatsRoute,
  StyleguideRoute: StyleguideRoute,
  TunerRoute: TunerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
